export interface FareResult {
  baseFare: number;
  timeBonus: number;
  cleanBonus: number;
  total: number;
}

export function baseFare(distanceTiles: number): number {
  return 8 + 0.8 * distanceTiles;
}

export function timeBonus(expectedSec: number, actualSec: number): number {
  const raw = (expectedSec - actualSec) * 0.5;
  const cap = expectedSec * 0.4;
  if (raw <= 0) return 0;
  return raw > cap ? cap : raw;
}

export function cleanBonus(subtotal: number, wasClean: boolean): number {
  return wasClean ? 0.5 * subtotal : 0;
}

export function totalFare(
  distanceTiles: number,
  expectedSec: number,
  actualSec: number,
  wasClean: boolean,
): FareResult {
  const base = baseFare(distanceTiles);
  const tb = timeBonus(expectedSec, actualSec);
  const cb = cleanBonus(base + tb, wasClean);
  return { baseFare: base, timeBonus: tb, cleanBonus: cb, total: base + tb + cb };
}
